// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__jRcom","primary":"Button_primary__VIPCG","secondary":"Button_secondary__zlSfz","outline":"Button_outline__LgVks"};